module.exports = __webpack_public_path__ + "static/media/Status_New.7f576a26.svg";